import { render, staticRenderFns } from "./c-input-tag.vue?vue&type=template&id=12c83b78&"
import script from "./c-input-tag.vue?vue&type=script&lang=js&"
export * from "./c-input-tag.vue?vue&type=script&lang=js&"
import style0 from "./c-input-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports